<template>
<e-chart ref="chart" />
</template>

<script>
export default {
  name: 'AQIExcellentRateChart',
  props: {
    data: {
      required: true,
      type: Object
    }
  },
  methods: {
    render (isReal) {
      let {series, dataTime} = this.data

      let chartOpt = {
        // title: {
        //   text: title
        // },
        toolbox: {
          feature: {
            saveAsImage: {}
          },
          right: 10
        },
        legend: {
          data: dataTime,
          bottom: 10
        },
        tooltip: {
          trigger: 'item',
          formatter: (arg) => {
            return arg.name + ' ' + arg.percent + '%'
          }
        },
        grid: [{
          top: 40,
          right: 40,
          bottom: 45,
          left: 30,
          containLabel: true
        }],
        color: ['#32CD32', '#CD853F', '#fac858', '#FC5474', '#73c0de', '#BD97EB', '#00C2DF', '#9a60b4', '#ea7ccc'],
        series: series
      }

      this.$refs.chart.setOpt(chartOpt)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Data/AQIExcellentRateChart.vue